import { forwardRef } from 'react';

import { Button, type ButtonBaseProps } from '../Button';

interface PillProps extends Omit<ButtonBaseProps, 'pressed'> {
  active?: boolean;
  isRounded?: boolean;
}

export const Pill = forwardRef<HTMLButtonElement, PillProps>(({ active = false, isRounded = true, ...props }, ref) => (
  <Button data-cxy-name="pill" pressed={active} ref={ref} rounded={isRounded} variant="tertiary" {...props} />
));

Pill.displayName = 'Pill';
